import { toast } from "sonner";
import { errText, downloadFile } from "../../../lib/api";
import { FileText, Trash } from "@phosphor-icons/react";

const sizeKb = (size) => `${(size / 1024).toFixed(1)} KB`;

export const CompanyDocList = ({ docs, onDelete }) => (
  <div className="bg-white border border-stone-200 rounded-lg divide-y divide-stone-100">
    {docs.length === 0 && <p className="py-10 text-center text-sm text-stone-400">No documents published yet.</p>}
    {docs.map((d) => (
      <div key={d.id} className="p-4 flex items-center justify-between gap-3" data-testid={`company-doc-row-${d.id}`}>
        <div className="flex items-center gap-3 min-w-0">
          <FileText size={24} weight="duotone" className="text-primary shrink-0" />
          <div className="min-w-0">
            <div className="font-semibold text-sm truncate">{d.title}</div>
            <div className="text-xs text-stone-500">{d.category}{d.department ? ` · ${d.department}` : " · Company-wide"} · {sizeKb(d.size)} · by {d.uploaded_by}</div>
          </div>
        </div>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => downloadFile(`/company-documents/${d.id}/download`, d.original_filename).catch((e) => toast.error(errText(e)))}
            data-testid={`download-company-doc-${d.id}`} className="text-primary font-bold text-xs hover:underline">Download</button>
          <button onClick={() => onDelete(d.id)} data-testid={`delete-company-doc-${d.id}`}
            className="text-stone-400 hover:text-red-600 transition-colors duration-200"><Trash size={16} /></button>
        </div>
      </div>
    ))}
  </div>
);
